var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5667 5.10934C12.2251 4.93644 11.8211 4.97043 11.513 5.19824L6.75358 8.71377H3.61433C2.72411 8.71377 2 9.43904 2 10.3307V14.6695C2 15.5611 2.72411 16.2864 3.61433 16.2864H6.75358L11.513 19.8019C11.6905 19.9333 11.9 20 12.1109 20C12.2659 20 12.4218 19.964 12.5664 19.8905C12.9081 19.7176 13.1205 19.3721 13.1205 18.9884V6.01143C13.1205 5.62804 12.9084 5.28224 12.5667 5.10934ZM3.009 14.6692V10.3303C3.009 9.99598 3.2805 9.72404 3.61433 9.72404H6.41518V15.2752H3.61433C3.2805 15.2752 3.009 15.0035 3.009 14.6692ZM12.1118 18.9881L7.42417 15.5255V9.47401L12.1122 6.0111L12.1118 18.9881Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9077 9.72072C14.6737 9.5694 14.3614 9.63672 14.2103 9.87107C14.0593 10.1054 14.1265 10.4182 14.3605 10.5695C15.018 10.9948 15.4106 11.7164 15.4106 12.4995C15.4106 13.2827 15.018 14.0043 14.3605 14.4296C14.1265 14.5809 14.0593 14.8937 14.2103 15.128C14.3069 15.2777 14.4691 15.3591 14.6346 15.3591C14.7282 15.3591 14.8232 15.333 14.9077 15.2784C15.854 14.6659 16.4192 13.6272 16.4192 12.4995C16.4192 11.3719 15.854 10.3332 14.9077 9.72072Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeLow);
export default __webpack_public_path__ + "static/media/Volume-Low.aef1e3c0290162083385af0e208b70e2.svg";
export { ForwardRef as ReactComponent };